export const ValidationEnum = (field) => {
  const validation = {};

  if (field.required) {
    validation.required = "Please enter a value.";
  }

  if (field.min) {
    validation.min = {
      message: `Minimum value is ${field.min}.`,
      value: Number(field.min),
    };
  }

  if (field.max) {
    validation.max = {
      message: `Maximum value is ${field.max}.`,
      value: Number(field.max),
    };
  }

  if (field.maxlength) {
    validation.maxLength = {
      message: `Maximum length is ${field.maxlength}.`,
      value: Number(field.maxlength),
    };
  }

  return validation;
};
